var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Status',{attrs:{"value":_vm.healthy,"ok-label":_vm.$t('servers.healthy'),"ko-label":_vm.$t('servers.unhealthy')}})
}
var staticRenderFns = []

export { render, staticRenderFns }